import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Grid, Flex } from '@chatterbug/aaron'

import OptionsMenu from 'src/ui/OptionsMenu/OptionsMenu'
import routes from 'src/lib/rails-routes/rails-routes'
import AppointmentModifyConfirmation from 'src/components/AppointmentModifyConfirmation/AppointmentModifyConfirmation'
import { t } from 'src/lib/i18n-react'
import OptionItem from 'src/ui/OptionsMenu/subcomponents/OptionItem'
import TutorAvatarPill from 'src/ui/TutorAvatarPill/TutorAvatarPill'

import AppointmentTime from './AppointmentTime'
import AppointmentStatus from './AppointmentStatus'
import AppointmentResponse from './AppointmentResponse'
import PotentialAppointmentResponse from './PotentialAppointmentResponse'
import AppointmentTrainingLabel from './AppointmentTrainingLabel'
import AppointmentBookable from './AppointmentBookable'

// TODO: should we add the 'canceled' status?

const STATUSES = {
  // searching = Unconfirmed tutor
  searching: 'TUTOR_PENDING',
  // pending = Unconfirmed student
  pending: 'PENDING',
  confirmed: 'CONFIRMED',
}

const AppointmentListItem = ({
  appointment,
  onCancel,
  onBookAsTrainer,
  onUpdateAppointment,
  onUpdatePotentialAppointment,
}) => {
  const [showModal, setShowModal] = useState(false)
  const {
    startTime,
    endTime,
    status,
    partner,
    language,
    isTraining = false,
    isBookable = false,
    hasConfirmedStudent,
  } = appointment
  const tutorIsPending =
    STATUSES[status] === 'TUTOR_PENDING' || STATUSES[status] === 'PENDING'

  const isPotentialAppointment = Boolean(onUpdatePotentialAppointment)
  const showActionButtons = isTraining || isPotentialAppointment
  const hideActionButtonsTraining =
    !showActionButtons || (isTraining && hasConfirmedStudent)

  return (
    <Flex flexDirection="column">
      {isTraining && <AppointmentTrainingLabel />}
      <Grid
        as="li"
        height={{ _: 'auto', tablet: 36 }}
        columns={{
          _: `auto 1fr 1fr ${showActionButtons ? '1fr' : '0.3fr'}`,
          mobile: `auto 1fr 1fr ${showActionButtons ? '1fr' : '0.3fr'}`,
          tablet: 'auto 2fr 0.75fr 1fr',
        }}
        gridGap="1x"
      >
        <AppointmentStatus
          status={isPotentialAppointment ? STATUSES.pending : STATUSES[status]}
          language={language}
        />
        <AppointmentTime startTime={startTime} endTime={endTime} />
        <Grid
          gridColumn={isTraining && { _: '3/-1', tablet: 'auto' }}
          alignSelf="center"
          justifySelf={{ _: 'end', tablet: 'auto' }}
          // TODOS: how exactly do we want to align the tutor pill?
          gridGap={showActionButtons ? null : '1x'}
          columns={{ _: '1fr auto' }}
        >
          <Flex alignItems="center">
            {!isPotentialAppointment && (
              <>
                {tutorIsPending && !isTraining ? (
                  <TutorAvatarPill isPending={tutorIsPending} />
                ) : (
                  partner && (
                    <TutorAvatarPill
                      name={partner.name}
                      avatarUrl={partner.avatarUrl}
                      isFavorite={partner.tutor?.isFavorite}
                      login={partner.login}
                    />
                  )
                )}
              </>
            )}
          </Flex>
        </Grid>
        {hideActionButtonsTraining && (
          <Flex data-testid="option-menu" justifySelf="end" alignItems="center">
            <OptionsMenu>
              {appointment.chatSessionId && (
                <OptionItem
                  href={routes.chat_show_preview(
                    appointment.language.code,
                    appointment.chatSessionId
                  )}
                  title={t('Preview exercises')}
                />
              )}
              <OptionItem
                handleClick={() => setShowModal(!showModal)}
                title={t('Cancel lesson')}
                destructive
              />
            </OptionsMenu>
            <AppointmentModifyConfirmation
              isOpen={showModal}
              onRequestClose={() => setShowModal(false)}
              onCancelAppointment={onCancel}
              status="cancel"
              appointment={appointment}
              isStudent={true}
              ctaButtonType="ctaAdvanced"
              tutorConfirmed={appointment.hasConfirmedTutor}
            />
          </Flex>
        )}
        <Grid
          gridColumn={{ _: '1/-1', tablet: 'auto' }}
          gridGap="1x"
          columns="1fr 1fr"
        >
          {!isBookable &&
            !hideActionButtonsTraining &&
            !isPotentialAppointment && (
              <AppointmentResponse
                onUpdateAppointment={onUpdateAppointment}
                appointmentId={appointment.id}
              />
            )}
          {isBookable && !hideActionButtonsTraining && (
            <AppointmentBookable
              onBookAsTrainer={onBookAsTrainer}
              appointmentId={appointment.id}
            />
          )}
          {showActionButtons && isPotentialAppointment && (
            <PotentialAppointmentResponse
              onUpdatePotentialAppointment={onUpdatePotentialAppointment}
            />
          )}
        </Grid>
      </Grid>
    </Flex>
  )
}

AppointmentListItem.propTypes = {
  appointment: PropTypes.object, //TODO: outline the shape
  onCancel: PropTypes.func,
  onUpdateAppointment: PropTypes.func,
  onUpdatePotentialAppointment: PropTypes.func,
  onBookAsTrainer: PropTypes.func,
}

export default AppointmentListItem
